
export default {
  api_base_url: 'https://mathbombs.org',
};
